/**
 * Checks if the provided color is a valid hex, RGB, or RGBA color.
 * If not, treats it as a CSS variable and attempts to retrieve its value.
 * 
 * @param {string} color - The color string to validate, which can be a hex, RGB, or CSS variable
 * @returns {string} - A valid color string or the CSS variable value
 */
export function getValidColor(color) {
    // Get the latest computed styles from the root element
    const rootStyles = getComputedStyle(document.documentElement)

    // Check if the color is in hex format (#RGB or #RRGGBB)
    const hexPattern = /^#([0-9A-F]{3}){1,2}$/i
    if (hexPattern.test(color)) {
        return color
    }

    // Check if the color is in RGB or RGBA format
    const rgbPattern = /^rgba?\((\s*\d+\s*,\s*){2,3}(\d+(\.\d+)?\s*)\)$/
    if (rgbPattern.test(color)) {
        return color
    }

    // If not a valid hex or RGB color, treat it as a CSS variable
    const cssVar = rootStyles.getPropertyValue(color.startsWith('--') ? color : `--${color}`).trim()
    return cssVar || color // Return the CSS variable's value or the original color if not found
}


/**
 * Resolves all CSS variables in a style object.
 * If a value is a CSS variable (e.g., var(--some-variable)), it resolves it using resolveStyleVariables.
 * 
 * @param {Object} styleObj - A style object containing key-value pairs of CSS properties
 * @returns {Object} - A new style object with resolved CSS variables
 */
export const resolveStyleVariables = (styleObj) => {

    // console.log('styleArray', styleObj)
    const resolvedStyle = {}

      for (const [key, value] of Object.entries(styleObj)) {
        // console.log('key/value', key, value)

        // Resolve only CSS variables (values starting with "--")
        resolvedStyle[key] = typeof value === 'string' && value.startsWith('--')
            ? getValidColor(value) // Resolve CSS variables
            : value // Keep raw values like integers or plain strings
    }

    return resolvedStyle
}



